// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__esoek","buttons":"SendReceipts_buttons__3OssH","email":"SendReceipts_email__3HQjS","bookApptTitle":"SendReceipts_bookApptTitle__22JAO"};